import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { TitleService } from '../../../services/title.service';

@Component({
  selector: 'app-terms-of-service-page',
  imports: [],
  templateUrl: './terms-of-service-page.html',
  styleUrl: './terms-of-service-page.scss',
})
export class TermsOfServicePage implements OnInit {
  constructor(private titleService: TitleService) {}

  ngOnInit(): void {
    this.titleService.setTitle('Terms of Service');
  }

  get appname(): string {
    return environment.appname;
  }
  get email(): string {
    return environment.email;
  }

  get address1(): string {
    return environment.address1;
  }

  get address2(): string {
    return environment.address2;
  }
}
